/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AccessGrantListEntryFromJSON, AccessGrantListEntryToJSON, } from './AccessGrantListEntry';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfAccessGrantListEntry interface.
 */
export function instanceOfPagedResponseOfAccessGrantListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfAccessGrantListEntryFromJSON(json) {
    return PagedResponseOfAccessGrantListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfAccessGrantListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(AccessGrantListEntryFromJSON))
    };
}
export function PagedResponseOfAccessGrantListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPage': PageRequestToJSON(value.nextPage),
        'previousPage': PageRequestToJSON(value.previousPage),
        'metaData': MetaDataToJSON(value.metaData),
        'numberOfElements': value.numberOfElements,
        'size': value.size,
        'page': value.page,
        'hasNext': value.hasNext,
        'hasPrevious': value.hasPrevious,
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(AccessGrantListEntryToJSON))
    };
}
